<h2 matDialogTitle>Validation Error</h2>
<mat-dialog-content>
  <span><mat-icon>warning</mat-icon> {{errorMessage}}</span>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button [matDialogClose]="true">
    <mat-icon>check</mat-icon>Ok</button>  
</mat-dialog-actions>